// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var RelayEnv = require("../../RelayEnv.bs.js");
var AgentInfo = require("../common/Agent/AgentInfo.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var Form__Validators = require("../../reason/common/Form/Form__Validators.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var InlineWarning__Jsx3 = require("../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ProfilePagePersonalInformationForm_agent_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_agent_graphql.bs.js");
var ProfilePagePersonalInformationFormEmailQuery_graphql = require("../../__generated__/ProfilePagePersonalInformationFormEmailQuery_graphql.bs.js");
var ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.bs.js");
var ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.bs.js");

var convertVariables = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertVariables;

var convertResponse = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateAgentProfileCompanyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function ProfilePagePersonalInformationForm$ForceBrokerageDialog(props) {
  var setCompanyInForm = props.setCompanyInForm;
  var match = use();
  var mutate = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setMutationErrored = match$1[1];
  var match$2 = React.useState(function () {
        return "";
      });
  var setBrokerage = match$2[1];
  var brokerage = match$2[0];
  var submit = function () {
    mutate({
          input: {
            company: brokerage
          }
        }, undefined, undefined, undefined, (function (response, param) {
            var match = response.updateAgentProfileCompany;
            if (match !== undefined) {
              setCompanyInForm(brokerage);
              return setMutationErrored(function (param) {
                          return false;
                        });
            } else {
              return setMutationErrored(function (param) {
                          return true;
                        });
            }
          }), undefined, undefined);
  };
  return JsxRuntime.jsxs(DialogV5.make, {
              title: "Set Your Brokerage",
              isOpen: Core__Option.isNone(Core__Option.flatMap(Core__Option.map(props.company, (function (c) {
                              return c.trim();
                            })), (function (c) {
                          return Form__Helpers.opt_of_string(c);
                        }))),
              ariaLabel: "Set your Brokerage",
              onDismiss: (function (prim) {
                  
                }),
              showCloseButton: false,
              children: [
                JsxRuntime.jsx(Text__Jsx3.make, {
                      lineHeight: {
                        NAME: "float",
                        VAL: 1.5
                      },
                      children: "Your profile is missing your brokerage information. Which brokerage do you belong to?"
                    }),
                match$1[0] ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsx(View__Jsx3.make, {
                                mb: "md"
                              }),
                          JsxRuntime.jsx(InlineWarning__Jsx3.make, {
                                children: "There was a problem setting your brokerage. Please try again..."
                              })
                        ]
                      }) : null,
                JsxRuntime.jsx(View__Jsx3.make, {
                      mb: "md"
                    }),
                JsxRuntime.jsx(Form__Input.make, {
                      onChange: (function (evt) {
                          var value = evt.target.value;
                          setBrokerage(function (param) {
                                return value;
                              });
                        }),
                      value: brokerage
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md",
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                onClick: (function (param) {
                                    submit();
                                  }),
                                disabled: brokerage.trim() === "" || match[1],
                                children: "Save"
                              }))
                    })
              ]
            });
}

var ForceBrokerageDialog = {
  UpdateAgentProfileCompanyMutation: UpdateAgentProfileCompanyMutation,
  make: ProfilePagePersonalInformationForm$ForceBrokerageDialog
};

var convertVariables$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertVariables;

var convertResponse$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertWrapRawResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables$1, ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1);

var useLoader = RescriptRelay_Query.useLoader(convertVariables$1, ProfilePagePersonalInformationFormEmailQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, convertVariables$1);

var fetchPromised = RescriptRelay_Query.fetchPromised(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, convertVariables$1);

var retain = RescriptRelay_Query.retain(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertVariables$1);

var Query_emailRegistrationStatus_decode = ProfilePagePersonalInformationFormEmailQuery_graphql.Utils.emailRegistrationStatus_decode;

var Query_emailRegistrationStatus_fromString = ProfilePagePersonalInformationFormEmailQuery_graphql.Utils.emailRegistrationStatus_fromString;

var Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email, initialEmail) {
  if (email === initialEmail) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
          email: email
        }, undefined, "network-only");
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return {
              TAG: "Error",
              _0: "something went wrong"
            };
    }
    throw exn;
  }
  var match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
            TAG: "Error",
            _0: "email is not available"
          };
  }
  var tmp = match.status;
  if ((tmp === "AVAILABLE" || tmp === "REGISTERED") && tmp === "AVAILABLE") {
    return {
            TAG: "Ok",
            _0: undefined
          };
  } else {
    return {
            TAG: "Error",
            _0: "email is not available"
          };
  }
}

var ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

var validators_email = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var email = Form__Helpers.noneIfEmpty(param.email);
      if (email === undefined) {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
      var email$1 = Scalars.EmailAddress.validate(email);
      if (email$1.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: email$1._0
              };
      } else {
        return {
                TAG: "Error",
                _0: "Please enter a valid email."
              };
      }
    }),
  validateAsync: Formality__Debouncer.make(700, (function (param) {
          var dispatch = param[2];
          var value = param[0];
          var validate = function (email, param) {
            return param.validateEmail(Scalars.EmailAddress.toString(email), param.initialEmail).then(function (res) {
                        if (res.TAG === "Ok") {
                          return {
                                  TAG: "Ok",
                                  _0: email
                                };
                        } else {
                          return {
                                  TAG: "Error",
                                  _0: res._0
                                };
                        }
                      });
          };
          Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                  dispatch({
                        TAG: "ApplyAsyncResultForEmailField",
                        _0: value,
                        _1: res
                      });
                }));
        })),
  eq: Caml_obj.equal
};

var validators_phone = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var phone = Form__Helpers.noneIfEmpty(param.phone);
      if (phone === undefined) {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var err = Form__Validators.isPhone(phone);
      if (err.TAG === "Ok") {
        if (err._0 === "Valid") {
          return {
                  TAG: "Ok",
                  _0: phone
                };
        } else {
          return {
                  TAG: "Ok",
                  _0: undefined
                };
        }
      } else {
        return {
                TAG: "Error",
                _0: err._0
              };
      }
    })
};

var validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var website = Form__Helpers.noneIfEmpty(param.website);
      if (website === undefined) {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var website$1 = Scalars.$$URL.fromString(website);
      if (website$1.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: Caml_option.some(website$1._0)
              };
      } else {
        return {
                TAG: "Error",
                _0: "Please enter a valid URL."
              };
      }
    })
};

var validators_company = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var company = Form__Helpers.noneIfEmpty(param.company);
      if (company !== undefined) {
        return {
                TAG: "Ok",
                _0: company
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_displayName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      return {
              TAG: "Ok",
              _0: param.displayName
            };
    })
};

var validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var lastName = Form__Helpers.noneIfEmpty(param.lastName);
      if (lastName !== undefined) {
        return {
                TAG: "Ok",
                _0: lastName
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var firstName = Form__Helpers.noneIfEmpty(param.firstName);
      if (firstName !== undefined) {
        return {
                TAG: "Ok",
                _0: firstName
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators = {
  email: validators_email,
  phone: validators_phone,
  website: validators_website,
  company: validators_company,
  displayName: validators_displayName,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(_input) {
  return {
          email: "Pristine",
          phone: "Pristine",
          website: "Pristine",
          company: "Pristine",
          displayName: "Pristine",
          lastName: "Pristine",
          firstName: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var value = fieldsStatuses.email;
  var tmp;
  tmp = typeof value !== "object" ? ({
        NAME: "Result",
        VAL: validators.email.validate(input, metadata)
      }) : (
      value.TAG === "Dirty" ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  var match = fieldsStatuses.phone;
  var tmp$1;
  tmp$1 = typeof match !== "object" ? validators.phone.validate(input, metadata) : match._0;
  var match$1 = fieldsStatuses.website;
  var tmp$2;
  tmp$2 = typeof match$1 !== "object" ? validators.website.validate(input, metadata) : match$1._0;
  var match$2 = fieldsStatuses.company;
  var tmp$3;
  tmp$3 = typeof match$2 !== "object" ? validators.company.validate(input, metadata) : match$2._0;
  var match$3 = fieldsStatuses.displayName;
  var tmp$4;
  tmp$4 = typeof match$3 !== "object" ? validators.displayName.validate(input, metadata) : match$3._0;
  var match$4 = fieldsStatuses.lastName;
  var tmp$5;
  tmp$5 = typeof match$4 !== "object" ? validators.lastName.validate(input, metadata) : match$4._0;
  var match$5 = fieldsStatuses.firstName;
  var tmp$6;
  tmp$6 = typeof match$5 !== "object" ? validators.firstName.validate(input, metadata) : match$5._0;
  var emailResult = tmp;
  if (emailResult.NAME !== "Result") {
    return {
            TAG: "Validating",
            fieldsStatuses: {
              email: emailResult.NAME === "Result" ? ({
                    TAG: "Dirty",
                    _0: emailResult.VAL,
                    _1: "Shown"
                  }) : ({
                    TAG: "Validating",
                    _0: emailResult.VAL
                  }),
              phone: {
                TAG: "Dirty",
                _0: tmp$1,
                _1: "Shown"
              },
              website: {
                TAG: "Dirty",
                _0: tmp$2,
                _1: "Shown"
              },
              company: {
                TAG: "Dirty",
                _0: tmp$3,
                _1: "Shown"
              },
              displayName: {
                TAG: "Dirty",
                _0: tmp$4,
                _1: "Shown"
              },
              lastName: {
                TAG: "Dirty",
                _0: tmp$5,
                _1: "Shown"
              },
              firstName: {
                TAG: "Dirty",
                _0: tmp$6,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  }
  var emailResult$1 = emailResult.VAL;
  var emailResult$2;
  if (emailResult$1.TAG === "Ok") {
    var phoneResult = tmp$1;
    if (phoneResult.TAG === "Ok") {
      var websiteResult = tmp$2;
      if (websiteResult.TAG === "Ok") {
        var companyResult = tmp$3;
        if (companyResult.TAG === "Ok") {
          var displayNameResult = tmp$4;
          if (displayNameResult.TAG === "Ok") {
            var lastNameResult = tmp$5;
            if (lastNameResult.TAG === "Ok") {
              var firstNameResult = tmp$6;
              if (firstNameResult.TAG === "Ok") {
                return {
                        TAG: "Valid",
                        output: {
                          firstName: firstNameResult._0,
                          lastName: lastNameResult._0,
                          displayName: displayNameResult._0,
                          company: companyResult._0,
                          website: websiteResult._0,
                          phone: phoneResult._0,
                          email: emailResult$1._0
                        },
                        fieldsStatuses: {
                          email: {
                            TAG: "Dirty",
                            _0: emailResult$1,
                            _1: "Shown"
                          },
                          phone: {
                            TAG: "Dirty",
                            _0: phoneResult,
                            _1: "Shown"
                          },
                          website: {
                            TAG: "Dirty",
                            _0: websiteResult,
                            _1: "Shown"
                          },
                          company: {
                            TAG: "Dirty",
                            _0: companyResult,
                            _1: "Shown"
                          },
                          displayName: {
                            TAG: "Dirty",
                            _0: displayNameResult,
                            _1: "Shown"
                          },
                          lastName: {
                            TAG: "Dirty",
                            _0: lastNameResult,
                            _1: "Shown"
                          },
                          firstName: {
                            TAG: "Dirty",
                            _0: firstNameResult,
                            _1: "Shown"
                          }
                        },
                        collectionsStatuses: undefined
                      };
              }
              emailResult$2 = emailResult$1;
            } else {
              emailResult$2 = emailResult$1;
            }
          } else {
            emailResult$2 = emailResult$1;
          }
        } else {
          emailResult$2 = emailResult$1;
        }
      } else {
        emailResult$2 = emailResult$1;
      }
    } else {
      emailResult$2 = emailResult$1;
    }
  } else {
    emailResult$2 = emailResult$1;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            email: {
              TAG: "Dirty",
              _0: emailResult$2,
              _1: "Shown"
            },
            phone: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            website: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            },
            company: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            },
            displayName: {
              TAG: "Dirty",
              _0: tmp$4,
              _1: "Shown"
            },
            lastName: {
              TAG: "Dirty",
              _0: tmp$5,
              _1: "Shown"
            },
            firstName: {
              TAG: "Dirty",
              _0: tmp$6,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurEmailField" :
                  var result = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: status,
                                  phone: init.phone,
                                  website: init.website,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result === undefined) {
                    return "NoUpdate";
                  }
                  var value = result.email;
                  if (typeof value === "object" && value.TAG !== "Dirty") {
                    var value$1 = value._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators_email.validateAsync([
                                      value$1,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: result,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case "BlurPhoneField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.phone, validators_phone, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: status,
                                  website: init.website,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurWebsiteField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.website, validators_website, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: init.phone,
                                  website: status,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurCompanyField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.company, validators_company, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: init.phone,
                                  website: init.website,
                                  company: status,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurDisplayNameField" :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.displayName, validators_displayName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: init.phone,
                                  website: init.website,
                                  company: init.company,
                                  displayName: status,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurLastNameField" :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: init.phone,
                                  website: init.website,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: status,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurFirstNameField" :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: init.email,
                                  phone: init.phone,
                                  website: init.website,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: status
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  switch (match$1.TAG) {
                    case "Valid" :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                        return {
                                TAG: "UpdateWithSideEffects",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: "Submitting",
                                    _0: tmp
                                  },
                                  submissionStatus: "AttemptedToSubmit"
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    onSubmit(output, {
                                          notifyOnSuccess: (function (input) {
                                              dispatch({
                                                    TAG: "SetSubmittedStatus",
                                                    _0: input
                                                  });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              dispatch({
                                                    TAG: "SetSubmissionFailedStatus",
                                                    _0: error
                                                  });
                                            }),
                                          reset: (function () {
                                              dispatch("Reset");
                                            }),
                                          dismissSubmissionResult: (function () {
                                              dispatch("DismissSubmissionResult");
                                            })
                                        });
                                  })
                              };
                    case "Invalid" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: "Editing",
                                  submissionStatus: "AttemptedToSubmit"
                                }
                              };
                    case "Validating" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateEmailField" :
                  var nextInput = action._0(state.input);
                  var nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  email: status,
                                  phone: init.phone,
                                  website: init.website,
                                  company: init.company,
                                  displayName: init.displayName,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  var value$2 = nextFieldsStatuses.email;
                  if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
                    var value$3 = value$2._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: nextInput,
                              fieldsStatuses: nextFieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators_email.validateAsync([
                                      value$3,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: nextFieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdatePhoneField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.phone, state.submissionStatus, validators_phone, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: status,
                                            website: init.website,
                                            company: init.company,
                                            displayName: init.displayName,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateWebsiteField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.website, state.submissionStatus, validators_website, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: init.phone,
                                            website: status,
                                            company: init.company,
                                            displayName: init.displayName,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateCompanyField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.company, state.submissionStatus, validators_company, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: init.phone,
                                            website: init.website,
                                            company: status,
                                            displayName: init.displayName,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateDisplayNameField" :
                  var nextInput$4 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.displayName, state.submissionStatus, validators_displayName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: init.phone,
                                            website: init.website,
                                            company: init.company,
                                            displayName: status,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateLastNameField" :
                  var nextInput$5 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: init.phone,
                                            website: init.website,
                                            company: init.company,
                                            displayName: init.displayName,
                                            lastName: status,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateFirstNameField" :
                  var nextInput$6 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            email: init.email,
                                            phone: init.phone,
                                            website: init.website,
                                            company: init.company,
                                            displayName: init.displayName,
                                            lastName: init.lastName,
                                            firstName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "ApplyAsyncResultForEmailField" :
                  var validator = validators_email;
                  var x = state.fieldsStatuses.email;
                  if (typeof x !== "object") {
                    return "NoUpdate";
                  }
                  if (x.TAG === "Dirty") {
                    return "NoUpdate";
                  }
                  if (!validator.eq(x._0, action._0)) {
                    return "NoUpdate";
                  }
                  var init = state.fieldsStatuses;
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: {
                              email: {
                                TAG: "Dirty",
                                _0: action._1,
                                _1: "Shown"
                              },
                              phone: init.phone,
                              website: init.website,
                              company: init.company,
                              displayName: init.displayName,
                              lastName: init.lastName,
                              firstName: init.firstName
                            },
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateEmail: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateEmailField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updatePhone: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdatePhoneField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateWebsite: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateWebsiteField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateCompany: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateCompanyField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateDisplayName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateDisplayNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateLastName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLastNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateFirstName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateFirstNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurEmail: (function () {
              dispatch("BlurEmailField");
            }),
          blurPhone: (function () {
              dispatch("BlurPhoneField");
            }),
          blurWebsite: (function () {
              dispatch("BlurWebsiteField");
            }),
          blurCompany: (function () {
              dispatch("BlurCompanyField");
            }),
          blurDisplayName: (function () {
              dispatch("BlurDisplayNameField");
            }),
          blurLastName: (function () {
              dispatch("BlurLastNameField");
            }),
          blurFirstName: (function () {
              dispatch("BlurFirstNameField");
            }),
          emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
          phoneResult: Formality.exposeFieldResult(state.fieldsStatuses.phone),
          websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
          companyResult: Formality.exposeFieldResult(state.fieldsStatuses.company),
          displayNameResult: Formality.exposeFieldResult(state.fieldsStatuses.displayName),
          lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
          firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.email;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.phone;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.website;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.company;
              if (typeof tmp$3 === "object") {
                return true;
              }
              var tmp$4 = match.displayName;
              if (typeof tmp$4 === "object") {
                return true;
              }
              var tmp$5 = match.lastName;
              if (typeof tmp$5 === "object") {
                return true;
              }
              var tmp$6 = match.firstName;
              if (typeof tmp$6 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              switch (match.TAG) {
                case "Valid" :
                    return true;
                case "Invalid" :
                    return false;
                case "Validating" :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertVariables$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertVariables;

var convertResponse$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$2, ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var UpdateAgentProfilePersonalInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$1,
  use: use$2
};

var convertFragment = ProfilePagePersonalInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$3,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePagePersonalInformationForm(props) {
  var agent = use$3(props.agent);
  var match = use$2();
  var updateAgentPersonalInfo = match[0];
  var match$1 = React.useState(function () {
        return agent.brokerage;
      });
  var setInitialBrokerage = match$1[1];
  var form = useForm({
        firstName: Core__Option.getOr(agent.firstName, ""),
        lastName: Core__Option.getOr(agent.lastName, ""),
        displayName: agent.userEnteredDisplayName,
        company: Core__Option.getOr(agent.brokerage, ""),
        website: Core__Option.map(agent.website, (function (w) {
                return Scalars.$$URL.toString(w);
              })),
        phone: agent.phone,
        email: Core__Option.getOr(Core__Option.map(agent.emailAddress, (function (e) {
                    return Scalars.EmailAddress.toString(e);
                  })), "")
      }, {
        validateEmail: validate,
        initialEmail: Core__Option.getOr(Core__Option.map(agent.emailAddress, (function (e) {
                    return Scalars.EmailAddress.toString(e);
                  })), "")
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          var company = param.company;
          updateAgentPersonalInfo({
                input: {
                  company: company,
                  displayName: param.displayName,
                  email: param.email,
                  firstName: param.firstName,
                  lastName: param.lastName,
                  phone: param.phone,
                  website: param.website
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateAgentProfilePersonalInfo = param.updateAgentProfilePersonalInfo;
                  if (updateAgentProfilePersonalInfo === undefined) {
                    return notifyOnFailure("Error updating data. Please refresh and try again...");
                  }
                  if (updateAgentProfilePersonalInfo.__typename !== "Agent") {
                    return notifyOnFailure("Error updating data. Please refresh and try again...");
                  }
                  notifyOnSuccess(undefined);
                  setInitialBrokerage(function (param) {
                        return company;
                      });
                }), undefined, undefined);
        }));
  var disabled = match[1] || form.submitting;
  var match$2 = form.firstNameResult;
  var tmp;
  tmp = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$2._0
      }) : undefined;
  var match$3 = form.lastNameResult;
  var tmp$1;
  tmp$1 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$3._0
      }) : undefined;
  var match$4 = form.displayNameResult;
  var tmp$2;
  tmp$2 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$4._0
      }) : undefined;
  var match$5 = form.companyResult;
  var tmp$3;
  tmp$3 = match$5 !== undefined && match$5.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$5._0
      }) : undefined;
  var match$6 = form.websiteResult;
  var tmp$4;
  tmp$4 = match$6 !== undefined && match$6.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$6._0
      }) : undefined;
  var match$7 = form.phoneResult;
  var tmp$5;
  tmp$5 = match$7 !== undefined && match$7.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$7._0
      }) : undefined;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(ProfilePagePersonalInformationForm$ForceBrokerageDialog, {
                      company: match$1[0],
                      setCompanyInForm: (function (company) {
                          form.updateCompany((function (v, value) {
                                  return {
                                          firstName: v.firstName,
                                          lastName: v.lastName,
                                          displayName: v.displayName,
                                          company: value,
                                          website: v.website,
                                          phone: v.phone,
                                          email: v.email
                                        };
                                }), company);
                          setInitialBrokerage(function (param) {
                                return company;
                              });
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                "Contact Information",
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                                            status: form.status,
                                            submissionErrorToString: (function (v) {
                                                return v;
                                              }),
                                            onSuccessMessage: "Account updated",
                                            resetForm: form.reset,
                                            dismissSubmissionResult: form.dismissSubmissionResult
                                          }),
                                      className: "my-4"
                                    })
                              ],
                              className: "text-2xl border-b pb-4 font-semibold mb-8"
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "First name:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          form.updateFirstName((function (v, value) {
                                                  return {
                                                          firstName: value,
                                                          lastName: v.lastName,
                                                          displayName: v.displayName,
                                                          company: v.company,
                                                          website: v.website,
                                                          phone: v.phone,
                                                          email: v.email
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurFirstName();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.firstNameResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: form.input.firstName
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Last name:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          form.updateLastName((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: value,
                                                          displayName: v.displayName,
                                                          company: v.company,
                                                          website: v.website,
                                                          phone: v.phone,
                                                          email: v.email
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurLastName();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.lastNameResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: form.input.lastName
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp$1
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Display name:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          var newDisplayName = $$event.target.value;
                                          form.updateDisplayName((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: v.lastName,
                                                          displayName: Form__Helpers.noneIfEmpty(value),
                                                          company: v.company,
                                                          website: v.website,
                                                          phone: v.phone,
                                                          email: v.email
                                                        };
                                                }), newDisplayName);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurDisplayName();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.displayNameResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: Core__Option.getOr(form.input.displayName, "")
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp$2
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Brokerage:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          var newCompany = $$event.target.value;
                                          form.updateCompany((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: v.lastName,
                                                          displayName: v.displayName,
                                                          company: value,
                                                          website: v.website,
                                                          phone: v.phone,
                                                          email: v.email
                                                        };
                                                }), newCompany);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurCompany();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.companyResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: form.input.company
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp$3
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Website:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          form.updateWebsite((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: v.lastName,
                                                          displayName: v.displayName,
                                                          company: v.company,
                                                          website: value,
                                                          phone: v.phone,
                                                          email: v.email
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      onBlur: (function (param) {
                                          var match = form.websiteResult;
                                          if (match !== undefined && match.TAG !== "Ok") {
                                            form.updateWebsite((function (v, value) {
                                                    return {
                                                            firstName: v.firstName,
                                                            lastName: v.lastName,
                                                            displayName: v.displayName,
                                                            company: v.company,
                                                            website: value,
                                                            phone: v.phone,
                                                            email: v.email
                                                          };
                                                  }), Form__Helpers.addHttp(Core__Option.getOr(form.input.website, "")));
                                          }
                                          form.blurWebsite();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.websiteResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: Core__Option.getOr(form.input.website, "")
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp$4
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Phone:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      type: "text",
                                      onChange: (function ($$event) {
                                          var value = $$event.target.value;
                                          form.updatePhone((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: v.lastName,
                                                          displayName: v.displayName,
                                                          company: v.company,
                                                          website: v.website,
                                                          phone: value,
                                                          email: v.email
                                                        };
                                                }), Form__Helpers.noneIfEmpty(Form__Helpers.stripNonDigits(value).slice(0, 10)));
                                        }),
                                      onBlur: (function (param) {
                                          form.blurPhone();
                                        }),
                                      disabled: form.submitting,
                                      status: Core__Option.map(form.phoneResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: Form__Helpers.formatAsPhone(Core__Option.getOr(form.input.phone, ""))
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldError.make, {
                                      valid: tmp$5
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(FormV5.FormGroup.make, {
                              label: "Email:",
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      placeholderText: "Enter your email",
                                      onChange: (function ($$event) {
                                          form.updateEmail((function (v, value) {
                                                  return {
                                                          firstName: v.firstName,
                                                          lastName: v.lastName,
                                                          displayName: v.displayName,
                                                          company: v.company,
                                                          website: v.website,
                                                          phone: v.phone,
                                                          email: value
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurEmail();
                                        }),
                                      disabled: false,
                                      status: Form__Helpers.resultAsyncToStatus(form.emailResult),
                                      value: form.input.email
                                    }),
                                JsxRuntime.jsx(Form__Components.FieldErrorAsyncV2.make, {
                                      valid: form.emailResult
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                    onClick: (function (extra) {
                                        return Form__Helpers.preventDefault(form.submit, extra);
                                      }),
                                    disabled: disabled,
                                    children: "Save"
                                  })
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: "Preview",
                                      className: "text-lg font-semibold mb-2"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(AgentInfo.make, {
                                            agent: agent.fragmentRefs,
                                            overrideBrokerage: form.input.company,
                                            overrideDisplayName: Core__Option.getOr(form.input.displayName, form.input.firstName + " " + form.input.lastName),
                                            linkToAgent: false,
                                            size: "medium"
                                          }),
                                      className: "p-4 border"
                                    })
                              ],
                              className: "mt-8"
                            })
                      ],
                      className: "flex flex-col my-8"
                    })
              ]
            });
}

var make = ProfilePagePersonalInformationForm;

exports.ForceBrokerageDialog = ForceBrokerageDialog;
exports.ValidateEmailAsync = ValidateEmailAsync;
exports.FormConfig = FormConfig;
exports.UpdateAgentProfilePersonalInfoMutation = UpdateAgentProfilePersonalInfoMutation;
exports.AgentFragment = AgentFragment;
exports.make = make;
/* commitMutation Not a pure module */
